let workerURL = require('./helpers/get-worker-url');
let bundleURL = require('./helpers/bundle-url');
let url = bundleURL.getBundleURL('59YxD') + require('./helpers/bundle-manifest').resolve("83hOY");module.exports = workerURL(url, bundleURL.getOrigin(url), true);